<template>
  <div>
    <section class="section">
      <!-- navbar -->
      <NavBarWizard />
      <!-- error -->
      <Error />
      <router-view />
    </section>
  </div>
</template>

<script>
import NavBarWizard from "@/components/NavBarWizard.vue";
import Error from "@/components/Error.vue";
//import { user } from "./../services/user";
export default {
  components: {
    NavBarWizard,
    Error,
  },
  data() {
    return {};
  },
  computed: {
    // queueState() {
    //   return this.$store.getters.queueState;
    // },
  },
  methods: {},
};
</script>
<style >
body {
  background-color: #90caf9 !important;
}
</style>